import React from 'react';
import styles from './UploadErrorList.module.css';

// Renders one line per rejected file. Shared by the three image pickers so a
// rejection never disappears silently the way it used to.
const UploadErrorList = ({ errors }) => {
    if (!errors?.length) return null;

    return (
        <div className={styles.uploadErrors} role="alert">
            {errors.map((message, index) => (
                <p key={index} className={styles.uploadErrorLine}>{message}</p>
            ))}
        </div>
    );
};

export default UploadErrorList;
